import {ConferencesOverviewSlider} from "./Components/ConferencesOverviewSlider";

document.addEventListener("DOMContentLoaded", function() {
    new ConferencesOverviewSlider().init();
})
